<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body form">
      <br />
      <div><h3>修改品牌下所有店家圖示</h3></div>
      <br />
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          排除的店家
        </span>
          <multiselect v-model="bindingStoreList"
                       placeholder="選擇排除的店家" label="label" track-by="value" :options="storeBrief"
                       :multiple="true" :allow-empty="true" :close-on-select="false"></multiselect>
          <!--<v-select v-model="bindingStoreList" :options="storeBrief" :multiple="true" class="h-38"></v-select>-->
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>種類
        </span>
          <div class="form-group">
            <select class="form-control" v-model="iconTypeSelect">
              <option v-for="iconType in iconTypeList" :value="iconType.value">{{iconType.label}}</option>
            </select>
          </div>
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
          <span class="input-group-addon">
            圖片
          </span>
          <div class="input-group-addon w-100-p text-center p-all-0 bg-white" style="border-right: none;">
            <span class="inline-block h-auto m-t-5">
              <div v-if="!storeInfo.image_name && (iconTypeSelect === 1 || iconTypeSelect === 4)" class="text-black" v-text="'沒有圖片'" />
              <img :src="storeInfo.image_name" class="h-auto img-responsive" v-if="storeInfo.image_name" data-toggle="modal">
            </span>
          </div>
          <div class="form-control h-100">
            <div v-if="imgLogoOption.length">
              <select class="form-control" v-model="imgLogoSelect">
                <option :value="img.name" v-for="(img, index) in imgLogoOption">{{img.name}}</option>
              </select>
            </div>
            <div>
              <label class="btn-upload btn btn-default" style="margin-top: 8px;" for="brand-img-load" :class="{'m-t-25': !imgLogoOption.length}">
                選擇圖片
              </label>
              <input class="form-control" type="file" style="display: none;" @change="onFileChange" id="brand-img-load">
            </div>
          </div>
        </div>
      </div>
      <div class="text-right text-15 text-red">(圖片大小為{{ iconTypeSelect === 1 ? '200x200': '800x460' }})<br /></div>
      <!--
      <div>
        <div class="input-group">
          <span class="input-group-addon">
            廣告左側圖片
          </span>
          <div class="input-group-addon w-100-p text-center p-all-0 bg-white" style="border-right: none;">
            <span class="inline-block h-auto m-t-5">
              <div v-if="!storeInfo.bg_image_name" class="text-black" v-text="'沒有圖片'" />
              <img :src="storeInfo.bg_image_name" class="h-auto img-responsive" v-if="storeInfo.bg_image_name" data-toggle="modal">
            </span>
          </div>
          <div class="form-control h-100">
            <div v-if="imgBgOption.length">
              <select class="form-control" v-model="imgBgSelect">
                <option :value="img.name" v-for="(img, index) in imgBgOption">{{img.name}}</option>
              </select>
            </div>
            <div>
              <label class="btn-upload btn btn-default" style="margin-top: 8px;" for="bg-img-load" :class="{'m-t-25': !imgBgOption.length}">
                選擇圖片
              </label>
              <input class="form-control" type="file" style="display: none;" @change="onBgChange" id="bg-img-load">
            </div>
          </div>
        </div>
      </div>
      <div class="text-right text-15 text-red">(圖片大小為625x300)<br /></div>
      -->
    </div>
    <div class="box-footer text-center">
      <router-link :to="'/storeTable/' + $route.params.brand_id">
        <button class="btn btn-default">
          取消
        </button>
      </router-link>
      <button class="btn btn-success" @click="updatedLogoImg">
        確定
      </button>
    </div>
    <br />
  </div>
</template>
<script>
import $ from 'jquery'
import ImgUploadTemp from './ImgUploadTemp.vue'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
// import moment from 'moment'
import VueTimepicker from 'vue2-timepicker'
// import 'src/static/js/plugins/notify/notify.min.js'
export default {
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      bindingStoreList: [],
      imgLogoOption: [],
      imgBgOption: [],
      storeBrief: [],
      imgLogoSelect: '',
      imgBgSelect: '',
      img: {
        width: 0,
        height: 0
      },
      bgImg: {
        width: 0,
        height: 0
      },
      deliveryOther: [],
      storeInfo: {
        image_name: '',
        bg_image_name: ''
      },
      iconTypeSelect: 1,
      iconTypeList: [
        { value: 1, label: 'logo' },
        { value: 4, label: '照片底圖' }
      ]
    }
  },
  methods: {
    init () {
      this.getBrandImgList()
      this.getStoreBrief()
    },
    onFileChange (e) {
      this.imgLogoSelect = ''
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else {
        this.createImage(files[0])
      }
    },
    createImage (file) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        if (self.storeInfo.image) self.storeInfo.image = img.src
        self.storeInfo.image_name = img.src
        img.onload = () => {
          self.img.width = img.width
          self.img.height = img.height
          self.checkImgSize()
        }
      }
      reader.readAsDataURL(file)
    },
    checkImgSize (type) {
      var self = this
      if (this.iconTypeSelect === 1 && (this.img.width !== 200 || this.img.height !== 200) && this.img.width !== 0 && this.img.height !== 0) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳200x200之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (this.iconTypeSelect === 4 && (this.img.width !== 800 || this.img.height !== 460) && this.img.width !== 0 && this.img.height !== 0) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x460之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      }
    },
    onBgChange (e) {
      this.imgBgSelect = ''
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      let imgSize = Math.round(files[0].size / 1000)
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else if (imgSize > 1024) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於1024KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.createBgImage(files[0])
      }
    },
    createBgImage (file) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        if (self.storeInfo.bg_image) self.storeInfo.bg_image = img.src
        self.storeInfo.bg_image_name = img.src
        img.onload = () => {
          self.bgImg.width = img.width
          self.bgImg.height = img.height
          self.checkBgImgSize()
        }
      }
      reader.readAsDataURL(file)
    },
    checkBgImgSize (type) {
      var self = this
      if ((this.bgImg.width !== 625 || this.bgImg.height !== 300) && this.bgImg.width !== 0 && this.bgImg.height !== 0) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.bgImg.width + 'x' + self.bgImg.height + '，請上傳625x300之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (type === 'cr') {
        // this.createdBrand()
      } else if (type === 'up') {
        // if ($('#brand-img-load')[0].files[0]) this.updatedIcon()
        // else this.updatedBrand()
      }
    },
    getStoreBrief () {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (i === 0) self.copyStoreSelect = sList[i].store_id
          }
        }
      })
    },
    getBrandImgList () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=1'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var logoList = response.data.list
          for (var i = 0; i < logoList.length; i++) {
            var option = {name: logoList[i].image_name, value: logoList[i].image_url}
            self.imgLogoOption.push(option)
          }
        }
      })
      var url2 = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=3'
      this.getDataH('get', url2, null, function (response) {
        if (response.data.status === 200) {
          var bgList = response.data.list
          for (var j = 0; j < bgList.length; j++) {
            var option2 = {name: bgList[j].image_name, value: bgList[j].image_url}
            self.imgBgOption.push(option2)
          }
        }
      })
    },
    updatedLogoImg () {
      var data = new FormData()
      // icon 圖片
      if (this.imgLogoSelect) {
        data.append('image_name', this.imgLogoSelect)
        this.upImg(data, 1)
      } else if ($('#brand-img-load')[0].files[0]) {
        data.append('image_file', $('#brand-img-load')[0].files[0])
        this.upImg(data, 1)
      } else this.updatedBgImg()
    },
    upImg (data, type) {
      var self = this
      let imgType = type
      if (type === 1 && this.iconTypeSelect !== 1) imgType = this.iconTypeSelect
      data.append('image_type', imgType)
      // 取得例外店家
      let string = ''
      for (let i = 0; i < this.bindingStoreList.length; i++) {
        string = string + this.bindingStoreList[i].value + ','
      }
      string = string.slice(0, -1)
      if (string) data.append('exception_stores', string)
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage'
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            if (type === 1) {
              self.$notify({
                title: '更新成功',
                text: '更新成功',
                duration: 3000,
                type: 'success',
                width: 400
              })
              self.$router.replace({path: '/storeTable/' + self.$route.params.brand_id})
              // self.updatedLogoImg()
            }
            /*
            else if (type === 3) {
              self.$notify({
                title: '更新成功',
                text: '更新成功',
                duration: 3000,
                type: 'success',
                width: 400
              })
              self.$router.replace({path: '/storeTable/' + self.$route.params.brand_id})
            }
            */
          }
        })
      }
    },
    updatedBgImg () {
      var data = new FormData()
      //  圖片
      if (this.imgBgSelect) {
        data.append('image_name', this.imgBgSelect)
        this.upImg(data, 3)
      } else if ($('#bg-img-load')[0].files[0]) {
        data.append('image_file', $('#bg-img-load')[0].files[0])
        this.upImg(data, 3)
      } else {
        this.$notify({
          title: '更新成功',
          text: '更新成功',
          duration: 3000,
          type: 'success',
          width: 400
        })
        this.$router.replace({path: '/storeTable/' + this.$route.params.brand_id})
      }
    }
  },
  created () {
    this.init()
  },
  components: {
    'img-upload': ImgUploadTemp,
    'date-time-picker': datetimePicker,
    VueTimepicker
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    },
    getInput () {
      var sInfo = this.storeInfo
      for (let key in sInfo) {
        if (!sInfo[key] && typeof sInfo[key] === 'object') sInfo[key] = ''
      }
      return {
        branch_code: this.checkInput(sInfo.branch_code.toString()),
        pos_branch_code: this.checkInput(sInfo.pos_branch_code.toString()),
        name: this.checkInput(sInfo.name.toString()),
        name_short: this.checkInput(sInfo.name_short.toString()),
        description: this.checkInput(sInfo.description.toString()),
        comment: this.checkInput(sInfo.comment.toString()),
        ein: this.checkInput(sInfo.ein.toString()),
        bl_name: this.checkInput(sInfo.bl_name.toString()),
        address_short: this.checkInput(sInfo.address_short.toString()),
        tel: this.checkInput(sInfo.tel.toString()),
        tel2: this.checkInput(sInfo.tel2.toString()),
        email: this.checkInput(sInfo.email.toString()),
        one_order_max_money: this.checkInput(sInfo.one_order_max_money.toString()),
        to_store_pay_max_money: this.checkInput(sInfo.to_store_pay_max_money.toString()),
        order_start_time_m: this.checkInput(sInfo.order_start_time_m.toString()),
        order_end_time_m: this.checkInput(sInfo.order_end_time_m.toString()),
        auto_reject_order_m: this.checkInput(sInfo.auto_reject_order_m.toString())
      }
    }
  },
  watch: {
    citySelect () {
      var cityCode = parseInt(this.citySelect, 10)
      var cityElement = this.cityAreaList.find(function (e, i, o) {
        return e.city_code === cityCode
      })
      let areaList = cityElement.area_list
      for (var i = 0; i < areaList.length; i++) {
        var option = {name: areaList[i].name, value: areaList[i].area_code}
        this.areaOption.push(option)
        if (i === 0 && this.$route.name !== 'upStore') this.areaSelect = areaList[i].area_code
      }
      if (this.$route.name === 'upStore') this.areaSelect = this.storeInfo.area_code
    },
    imgLogoSelect () {
      var self = this
      if (self.imgLogoSelect) {
        let imgSrc = this.imgLogoOption.find(function (e) {
          return e.name === self.imgLogoSelect
        }).value
        this.storeInfo.image_name = imgSrc
      }
    },
    imgBgSelect () {
      var self = this
      if (self.imgBgSelect) {
        let imgSrc = this.imgBgOption.find(function (e) {
          return e.name === self.imgBgSelect
        }).value
        this.storeInfo.bg_image_name = imgSrc
      }
    },
    'deliveryWaysInfo' () {
      this.checkOtherDelivery()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ChangeStoresIconTemp.vue?549cee37